import { render } from "./App.vue?vue&type=template&id=e86074de"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e86074de&lang=css"

import exportComponent from "/Users/emperinter/app/HTML/watermark-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__